export default __webpack_public_path__ + "static/media/title_ja_sp.758ca817.png";